<template>
  <div id="app">
    <headers activeIndex="/training"></headers>
    <div class="course-box" v-if="det">
      <div class="w_1605">
        <div class="course-box-title">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
          {{det.name}}
        </div>

        <div class="course-box-content">
          <div class="course-box-content-left" style="">
            <!-- <iframe src="//vpn.file.laodongjiaoyu.vip/uploads/20230311/de2b7163ca4b5ebfcbd0ee08c07080d9.mp4" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
            <iframe frameborder="0" :src="url" allowFullScreen="true"
              :style="'width: 100%;height: 100%;min-height: 740px;background: url('+det.image+') no-repeat;background-size:100%'"></iframe>
          </div>
          <div class="course-box-content-right">


            <div class="course-list">
              <h2>目录</h2>
              <ul class="ul-div">
                <el-menu default-active="2" class="el-menu-vertical-demo" background-color="rgba(0,0,0,0)" @select="handleSelect">
                  <el-submenu index="0">
                    <template slot="title">
                      <i class="iconfont icon-Vector"></i>
                      <span>课程简介</span>
                    </template>
                    <el-menu-item-group>
                      <div v-html="det.content"></div>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="1">
                    <template slot="title">
                      <i class="iconfont icon-Frame"></i>
                      <span>说课视频</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.videomedia" :key="item.id" :index="'1-'+key">{{item.name}}</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-submenu index="2" popper-class="active">
                    <template slot="title">
                      <i class="iconfont icon-a-Frame1"></i>
                      <span>教案</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item v-for="(item,key) in det.datamedia" :key="item.id" :index="'2-'+key">{{item.name}}</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    coursedetail,
    trainingdetail
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        det: '',
        url: ''
      }
    },
    methods: {
      editurl(url) {
        this.url = url
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath,parseInt(key.slice(2)));
        if(keyPath[0]==1){
          this.url=this.det.videomedia[parseInt(key.slice(2))].videourl
        }else{
          this.url=this.det.datamedia[parseInt(key.slice(2))].fileurl
        }
        // this.det.video
      }
    },
    created() {
      trainingdetail({
        training_id: this.$route.query.id
      }).then(res => {
        if(res.code){
          this.det = res.data
          // this.url = this.det.videomedia[0].videourl
        }else{
          this.$message({
            message: res.msg,
            type: 'error'
          });
          this.$router.go(-1)
        }
      })
    }
  }
</script>

<style scoped>
  @import '../../assets/css/home.css';
  .ul-div .el-menu-item .is-active{
    background-color: #22AC38 !important;
    color: #fff !important;
  }
  .el-submenu__title *{
    font-size: 16px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/tradet.vue